import { FormControlLabel, Grid, Switch } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import React, { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { USER_ALERT_STATUS } from "../../util/constants"
import { FILTER_TYPE } from "../../util/filters/filterConstants"
import { FilterManager } from "../../util/filters/filterManager"
import CustomTableContainer from "../Common/Table/CustomTableContainer"
import AckAllAlertsModal from "./ackAllModal"
import AlertSettingModal from "./alertSettingModal"
import ResolveAllAlertsModal from "./resolveAllModal"

const useStyles = makeStyles({
  grid: {
    marginBottom: 10,
  },
})

export default function AlertsTable() {
  const [processedAlerts, setProcessedAlerts] = useState([])
  const [showResolved, setShowResolved] = useState(false)
  const alerts = useSelector((state) => state.alerts.alerts)
  const alertSettings = useSelector((state) => state.alerts.alertSettings)
  const groups = useSelector((state) => state.group.groupData)
  const classes = useStyles()

  const filterManagerRef = useRef(null)
  if (!filterManagerRef.current) {
    filterManagerRef.current = FilterManager.Builder.addFilter(FILTER_TYPE.ALERT.STATUS_ICON, true)
      .addFilter(FILTER_TYPE.ALERT.STATUS_TEXT, false)
      .addFilter(FILTER_TYPE.ALERT.TYPE, false)
      .addFilter(FILTER_TYPE.ALERT.SUMMARY, true)
      .addFilter(FILTER_TYPE.ALERT.KEY, true)
      .addFilter(FILTER_TYPE.ALERT.ASSOCIATED_ID, true)
      .addFilter(FILTER_TYPE.ALERT.CREATED_AT, true)
      .addFilter(FILTER_TYPE.ALERT.ACTION, true)
      .build()
  }
  const filterManager = filterManagerRef.current

  useEffect(() => {
    if (alerts) {
      setProcessedAlerts(
        alerts
          .filter((alert) => showResolved || alert.status !== USER_ALERT_STATUS.RESOLVED)
          .map((alert, index) => {
            return {
              ...filterManager.generateDataMap(
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                alert,
              ),
              id: index,
              alert,
              no_click: true,
            }
          }),
      )
    }
  }, [alerts, showResolved, filterManager.generateDataMap])

  return (
    <>
      <Grid container direction="row-reverse" justifyContent="flex-end" className={classes.grid}>
        <FormControlLabel
          checked={showResolved}
          onChange={() => setShowResolved(!showResolved)}
          control={<Switch />}
          label="Show Resolved"
        />
        <ResolveAllAlertsModal />
        <AckAllAlertsModal />
      </Grid>
      <CustomTableContainer
        defaultOrder="desc"
        defaultOrderHeader={FILTER_TYPE.ALERT.CREATED_AT}
        headers={filterManager.getHeaders()}
        filterManager={filterManager}
        rowData={processedAlerts}
        paginationOptions={[5, 10, 25, 50, 100]}
        defaultPaginationOption={25}
        clickAction={() => {}}
        swipeable={true}
        insightsTable={false}
        AdditionalToolbar={
          <AlertSettingModal
            groups={groups}
            settings={alertSettings?.settings}
            groupSettings={alertSettings?.groupSettings}
          />
        }
        UnsavedChangesSnackbar={false}
      />
    </>
  )
}
